import type { GetClassAdapterOptions } from '@nextgis/ngw-kit';
import type { Type } from '@nextgis/utils';
import type { MainLayerAdapter, TileAdapterOptions } from '@nextgis/webmap';

// import { TmsClientLayer } from 'src/types/TmsClientLayer';
// import { TmsClientConnection } from 'src/types/TmsClientConnection';

export async function createTerrainProviderAdapter(
  options: GetClassAdapterOptions,
): Promise<Type<MainLayerAdapter<any, any, TileAdapterOptions>> | undefined> {
  const item = options.item;
  if ('terrain_provider' in item) {
    const TerrainAdapter = options.webMap.mapAdapter.layerAdapters
      .TERRAIN as Type<MainLayerAdapter<any, any, TileAdapterOptions>>;
    const connector = options.connector;
    const url =
      (connector.options.baseUrl || '') +
      `/api/resource/${item.resource.id}/terrain_provider`;
    class NgwTerrainAdapter extends TerrainAdapter {
      async addLayer() {
        return super.addLayer({
          url,
          attribution: item.resource.display_name,
          headers: connector.getAuthorizationHeaders(),
        });
      }
    }
    return NgwTerrainAdapter;
  }
}
